var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "a-row",
        { attrs: { type: "flex" } },
        [
          _c("a-col", { attrs: { flex: "50px" } }),
          _c(
            "a-col",
            { attrs: { flex: "auto" } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 4 } },
                [
                  _c("a-col", { attrs: { span: 5 } }, [
                    _c("span", { staticClass: "list-header" }, [
                      _vm._v("监测项目名称"),
                    ]),
                  ]),
                  _c("a-col", { attrs: { span: 7 } }, [
                    _c("span", { staticClass: "list-header" }, [
                      _vm._v("牵头单位"),
                    ]),
                  ]),
                  _c("a-col", { attrs: { span: 3 } }, [
                    _c("span", { staticClass: "list-header" }, [
                      _vm._v("归属行业"),
                    ]),
                  ]),
                  _c("a-col", { attrs: { span: 7 } }, [
                    _c("span", { staticClass: "list-header" }, [
                      _vm._v("监测执行标准"),
                    ]),
                  ]),
                  _c("a-col", { attrs: { span: 2 } }),
                ],
                1
              ),
              _vm._l(_vm.localValue, function (item) {
                return _c(
                  "a-row",
                  { style: { margin: "12px" }, attrs: { gutter: 4 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 5 } },
                      [
                        _c("a-input", {
                          attrs: { placeholder: "请填写项目名称" },
                          model: {
                            value: item.taskName,
                            callback: function ($$v) {
                              _vm.$set(item, "taskName", $$v)
                            },
                            expression: "item.taskName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 7 } },
                      [
                        _c("a-input", {
                          attrs: { placeholder: "请选择牵头单位" },
                          model: {
                            value: item.leaderDw,
                            callback: function ($$v) {
                              _vm.$set(item, "leaderDw", $$v)
                            },
                            expression: "item.leaderDw",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 3 } },
                      [
                        _c("a-input", {
                          attrs: { placeholder: "请选择行业" },
                          model: {
                            value: item.hangye,
                            callback: function ($$v) {
                              _vm.$set(item, "hangye", $$v)
                            },
                            expression: "item.hangye",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 7 } },
                      [
                        _c("a-input", {
                          attrs: { placeholder: "请选择执行标准" },
                          model: {
                            value: item.biaozhun,
                            callback: function ($$v) {
                              _vm.$set(item, "biaozhun", $$v)
                            },
                            expression: "item.biaozhun",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 2 } },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "link" },
                            on: {
                              click: function ($event) {
                                return _vm.removeItem(item)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "link", icon: "download" },
                          on: { click: _vm.addItem },
                        },
                        [_vm._v(" 添加新监测项目 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "big-title" }, [
      _c("span", [_vm._v("添加监测项目")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }